(function () {
  'use strict';

  if (typeof customElements === 'undefined' || customElements.get('tk-video-bg')) return;

  var REDUCED_MOTION = '(prefers-reduced-motion: reduce)';

  class TkVideoBg extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;

      // Reduced motion: non avviare, resta il poster.
      if (window.matchMedia && window.matchMedia(REDUCED_MOTION).matches) return;

      this.observer = new IntersectionObserver(this.onIntersect.bind(this), { threshold: 0.1 });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    onIntersect(entries) {
      var entry = entries[0];
      if (!entry) return;
      if (entry.isIntersecting) {
        if (this.video.paused) {
          var played = this.video.play();
          if (played && played.catch) played.catch(function () {});
        }
      } else if (!this.video.paused) {
        this.video.pause();
      }
    }
  }

  customElements.define('tk-video-bg', TkVideoBg);
})();
